export const convertCountryBoundsToGoogleLatLng = (bounds: {
    south: number;
    west: number;
    north: number;
    east: number;
}) => {
    const southwest = new google.maps.LatLng(bounds.south, bounds.west);
    const northeast = new google.maps.LatLng(bounds.north, bounds.east);
    return new google.maps.LatLngBounds(southwest, northeast);
};
